<script>
import { showURL } from '@/modules/helper/index'
  import * as Helper from "@/modules/helper/index"
  import DeviceInfo from '@/modules/util/deviceInfo'
  import { mapGetters, mapActions } from "vuex";
  export default {
    data() {
      return {
        Pdfdata: [],
        dataLoaded: false
      };
    },
    computed: {
      ...mapGetters(['DesignSettings', 'AppConfig', 'Pdf', 'pdfDocList', 'resource']),
      SubscriptionModuleId() {
        return this.$f7route.params.Id;
      }
    },
    created() {
      this.initPdfModule(this.SubscriptionModuleId)
    },
    methods: {
      ...mapActions([
        'loadLocalPdf',
        'loadPdf',
        'updatePDFDocList',
        'loadPDFData'
      ]),
      async initPdfModule(SubscriptionModuleId) {
        this.$showLoader()
        this.loadLocalPdf(SubscriptionModuleId)
        this.loadPdf(SubscriptionModuleId).then(async () => {
          var formData = new FormData()
          let param = this.$store.getters.AppConfig.Subscription_GUID + '/app/pdf/' + this.SubscriptionModuleId + '/'
          formData.append('dir', param)
          this.Pdfdata = await this.loadPDFData(formData)
          this.updatePDFDocList(this.Pdfdata)
          this.dataLoaded = true
          this.$hideLoader()
          this.$RegisterPageView({
            'SubscriptionModule_Id': SubscriptionModuleId,
            'ContentGUID': this.Pdfdata.Id,
            'ViewType': 1
          })
        }).catch(err => {
          console.log('err', err)
          this.dataLoaded= false
          this.$hideLoader()
        })
      },
      GetpdfUrl (name) {
        let url = this.$store.getters.AppConfig.Urls.ContentBaseUrl + '/' + this.$store.getters.AppConfig.Subscription_GUID + '/app/pdf/'+  this.SubscriptionModuleId + '/' + name
        return url
      },
      onClickImage(linkURL) {
          if (Helper.IsUserActionAllow()) {
          showURL(this.$store.getters.AppConfig.Urls.ContentBaseUrl + '/' +this.$store.getters.AppConfig.Subscription_GUID + '/app/pdf/'+  this.SubscriptionModuleId + '/' + linkURL, this.DesignSettings.AppThemeColor, this.DesignSettings.AppThemeFontColor)
        } else {
          let modalOptions = {
            title: this.resource.warningTitle,
            text: this.resource.warningMessage,
            buttonText: this.resource.closeBtn,
            downloadbuttonText: DeviceInfo.isAndroid ? this.resource.AndroidDownload : this.resource.AppleDownload,
            $f7: this.$f7
          }
          this.$showModal(modalOptions)
        }
      }
    }
  };
</script>
<template>
  <f7-page ref="Pdf" :page-content="false" name="pdf-view">
    <app-header :header="Pdf.PageTitle" ></app-header>
    <div class="backgroundimg"></div>
    <div  class="page-content">
        <div v-if="dataLoaded">
            <div  class="album-wrapper row">
              <div v-for="(val,index) in pdfDocList"  :key="index" class="col-50 tablet-33 album-margin">
                <a  @click="onClickImage(val.label)" class="album-link link">
                <div class="image-gallery-control sort-handle" >
                <i class="pdf-icon"></i>
                </div>
                  </a>
                  <div class="album-name">{{val.label.replace('.pdf', '')}}</div>
              </div>
            </div>
        </div>
    </div>
  </f7-page>
</template>

<style scoped>
.image-iframe {
  width: 118px;
  height: 180px;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  top: -57px;
  left: -1px;
}
.image-gallery-control {
  width: 99px;
  height: 119px;
  margin: 0 1vh 1vh 0;
  position: relative;
  float: left;
  overflow: hidden;
}
  .ios .page-with-subnavbar .page-content {
    padding-top: 44px
  }
  .album-wrapper > div .album-link {
    display: inline-block;
    padding: 20px 0 6px;
    vertical-align: top;
    margin-top: 20px;
    position: relative;
    font-size: 14px;
    line-height: 18px;
  }

  .album-image-wrapper {
    position: relative;
    width: 105px;
    margin: 0 auto 20px;
  }

  .album-wrapper > div .album-link .album-images {
    border: 5px solid #fff;
    overflow: hidden;
    width: 105px;
    height: 105px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top center;
  }

  .album-wrapper > div {
    text-align: center;
  }

  .album-link .album-image-wrapper:before,
  .album-link .album-image-wrapper:after {
    content: "";
    width: 115px;
    height: 115px;
    position: absolute;
    box-sizing: border-box;
    box-shadow: 0 1px 18px rgba(0, 0, 0, 0.4);
    transition: 0.3s all ease-out;
  }
  .album-info {
    font-size: 11px;
    /*color: #fff;*/
    display: flex;
    justify-content: space-around;
  }
  .album-margin {
    margin-bottom: 25px;
  }
  .album-info .icon-dislike-them-color {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-left: 5px;
  }

  .album-name {
    max-height: 38px;
    white-space: nowrap;
    text-transform: capitalize ;
    max-width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: -20px auto;
  }

  @media only screen and (min-width: 768px) {
    .album-wrapper {
      justify-content: flex-start !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pdf/Pdf.vue